import { createApiClient } from "./client";
import { ExamUser } from "./types/jointExam.types";

const client = createApiClient();

export const api = {
  getExam: ({ id }: {id: string}) => client.get(`/registration/pipelines/${id}`).then(({ data }) => data),
  loginToExam: (payload : ExamUser) => client
  .post(`/auth/register/exam`, payload).then(({ data }) => data),
  loginToExamLaunch: (payload : ExamUser) => client
  .post(`/auth/exam/registration/`, payload).then(({ data }) => data),
  checkExam: ({payload, id} : {payload: any, id: string}) => client
  .post(`/registration/pipelines/${id}`, payload).then(({ data }) => data),
  
  initiateAssessment: ({payload, id} : {payload: any, id: string}) => client
  .post(`/registration/pipelines/${id}/initiate-assessment`, payload).then(({ data }) => data),
  checkExamLaunch: (payload : any) => client
  .post(`/auth/exam/registration/confirm-email`, payload).then(({ data }) => data),

  checkExamResult: (payload : any) => client
  .post(`auth/check-results`, payload).then(({ data }) => data),

  getSelections: ({path}: {path: string}) => client.get(`${path}`).then(({ data }) => data),
};
